module.exports = __webpack_public_path__ + "static/media/feature-tile-icon-05.83bc3e5e.svg";